<template>
    <div class="m-userinfo">

        <p class="info-txt">
            <span>欢迎，</span>            
            <span class="player-name">{{ ($store.state.userinfo.nickName || uid_handler($store.state.userinfo.uid) )|e }}</span>
            <span v-if="!$store.state.userinfo.uid" class="login u-btn" @click="call_login">请【登录】</span> 
            <span class="area-name" v-if="$store.state.login && $store.state.userinfo.areaId">{{ area_dic[$store.state.userinfo.areaId] }}</span>
            <span v-if="$store.state.login && !$store.state.userinfo.areaId" class="bind" @click="$bind_modal()">【绑定大区】</span>
            <span v-if="$store.state.login && !KD.isApp()" class="logout u-btn" @click="call_logout">【退出】</span>          
        </p>
       
    </div>
</template>

<script>
import KD from '@/assets/js/kd.js';
import mslogin from '@/assets/js/msLogin.js';
import area_dic from '@/components/areadic.js';

export default {
    data (){
        return {
            KD : KD,
            area_dic : area_dic,
        }
    },
    props : {
        info : {
            default : () => {}
        },
        login_flag : {
            default : 0,
        },
    },
    filters : {
        e(str) {return str || '仙术师'}
    },    
    methods : {
        call_login(){
            mslogin.open();
        },

        call_logout(){
            var _this = this;
            localStorage.clear();
            setTimeout(function () { 
                //TODO   
                document.location = _this.$global.domain;
            }, 100);             
        },

        call_buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }            

            this.$buy_Modal();
        },

        switch_area (){
            this.$close_book();
            this.$bind_modal();
        },

        uid_handler(uid){
            return uid ? uid.toString().slice(0,6) + '****' : '仙术师'    
        },
    },
}
</script>

<style scoped>
    .m-userinfo{
        /* display: flex; */
        position: relative;
        text-align: center;
        z-index: 10;
    }

    .u-btn.logout,
    .u-btn.login{
        /* color: #fff7c9; */
    }

    .login-state{
        /* height: 30px;
        line-height: 30px; */
    }

    /* @media not all and (min-width:900px){
        .m-userinfo{
            width: 750px;
            justify-content: center;
            font-size: 24px;
        }
    } */
</style>


// WEBPACK FOOTER //
// src/components/userinfo.vue